import React from 'react';
import FlexView from 'react-flexview/lib';
import { Divider } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowForward';

export const AdditionalInsuredsCertificates = ({shrink, setShowAddAdditionalInsuredCertificatePopup }) => {
    return (
        <>
            <FlexView vAlignContent="center" className="space-between padding-vertical-basic">
                <span className="text-body bold">Additional Insured Certificates</span>
                <FlexView 
                    onClick={() => setShowAddAdditionalInsuredCertificatePopup(true)} 
                    vAlignContent="center" 
                    className="blue clickable"
                >
                    {!shrink && <FlexView className='bold' marginRight={8}>
                        Download
                    </FlexView>}
                    <ArrowRightIcon fontSize="small" className="margin-right-small" />
                </FlexView>
            </FlexView>
            <Divider />
        </>
    );
}; 